import  $  from 'jquery';
window.jQuery = $;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { Draggable } from "gsap/Draggable";
import { SplitText } from "gsap/SplitText";


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother, Draggable ,SplitText);


import barba from '@barba/core';
import Cookies from 'js-cookie';
import IonRangeSlider from 'ion-rangeslider';


window.jQuery = $;
require('@fancyapps/fancybox');
const houses = {
    $floors : null,
    $houseTooltip: null,
    init: function(container = document, scroller){
        let obj = this;

        obj.$houseTooltip = $(container).find('.tooltip-house');
        obj.$houseTooltip.addClass('show');


        let delay = null;

        obj.$floors = $(container).find('.svg-houses a');
        obj.$container = $(container).find('.sct-houses--inner');


        obj.$floors.on('mouseenter', function(){
            let $this = $(this);
            let house = $this.data('house');
            let floor = $this.data('floor');
            let $houseTooltip  = $('.tooltip-house[data-house="'+house+'"]');
            if($this.hasClass('inactive')){
                $houseTooltip.find('.tooltip-house--bot').hide();
                $houseTooltip.find('.tooltip-house--parking').hide();
                $houseTooltip.find('.tooltip-house--floor').hide();
            }else{

                $houseTooltip.find('.tooltip-house--floor span').html(floor);
                $houseTooltip.find('.tooltip-house--available span').html(houses_info[house][floor]);
              //  $houseTooltip.find('.tooltip-house--floor').show();

                $houseTooltip.addClass('show-floor');

                if(floor === 'P'){
                    $houseTooltip.find('.tooltip-house--bot').hide();
                    $houseTooltip.find('.tooltip-house--parking').show();
                }else{
                    $houseTooltip.find('.tooltip-house--parking').hide();
                    $houseTooltip.find('.tooltip-house--bot').show();
                }
            }
            $houseTooltip.addClass('active').removeClass('static');

        }).on('mousemove', function(e){
            let $this = $(this);
            let house = $this.data('house');
            let $houseTooltip  = $('.tooltip-house[data-house="'+house+'"]');
            let left = e.clientX;
            let top = e.clientY;

            delay = setTimeout(function(){
              $houseTooltip.addClass('moving');
            },400);

            $houseTooltip
                .css({
                    top:  top  + -(obj.$container[0].getBoundingClientRect().y) - $houseTooltip.height() - 10,
                    left : left + 3,
                    opacity: 1
                });

        }).on('mouseleave', function(){
            let $this = $(this);
            let house = $this.data('house');
            let $houseTooltip  = $('.tooltip-house[data-house="'+house+'"]');
            $houseTooltip.find('.tooltip-house--available span').html(houses_info[house]['total']);
            $houseTooltip.removeClass('active');
            $houseTooltip.addClass('static').removeClass('moving').removeClass('show-floor');
            $houseTooltip.find('.tooltip-house--parking').hide();
        })




    }
}
const filter = {


    init: function(container = document){

        let $filter = $(container).find('.filter-form');
        let $houses = $filter.find('.house-select');
        let $sliders = $filter.find('.slider');
        let $inputs = $filter.find('.filter-inputs input, .filter-extra input');
        let $list = $filter.next('.filter-results');

        $inputs.on('change', function(){
            $filter.submit();
        })

        if($sliders.length > 0 ){
            $.each($sliders, function(){
                let $this = $(this);
                $this.ionRangeSlider({
                    onFinish: function(data){
                        $filter.submit();
                    }
                });
            })
        }

        $filter.submit(function(e){
            e.preventDefault();
            let $this  = $(this);
            $.ajax({
                url:$this.attr('action'),
                data: $this.serialize(),
                type: 'POST',
                beforeSend: function(){ }
            }).done(function(data){
                data = JSON.parse(data);
                if($list.length > 0){
                    $list.html(data.html);
                }
                let url = window.location.href;
                url = url.split('?');
                tooltips.init($list);
                barba.history.add(url[0]+'?'+data.query, 'filter');
                triggerResize();

                let $reset = $list.find('.btn-reset');

                if($reset.length >0){
                    console.log($reset);
                }

            });
        });


        $houses.on('click', function(){
            let $this = $(this);
            let $input = $filter.find('#'+$this.data('for'));
            $this.toggleClass('clicked');
            if($input.prop('checked') === false){
                $input.prop('checked',true);
            }else{
                $input.prop('checked',false);
            }

            $filter.submit();

        });


        let $toggle = $(container).find('.filter-toggle');

        $toggle.on('click', function(){
            $(this).toggleClass('full');
            $filter.slideToggle();
        })

    }

}
const floors = {

    init:  function(container = document){
        let obj = this;

        if(typeof apart_data == 'undefined'){
            return false;
        }

        obj.$tooltip = $(container).find('.tooltip-floor');
        obj.$container = $(container).find('.section-floor--plan');

        let nr = obj.$tooltip.find('.tooltip-floor--nr h2');
        let type = obj.$tooltip.find('.tooltip-floor--type');
        let status = obj.$tooltip.find('.tooltip-floor--statusTxt');
        let price = obj.$tooltip.find('.tooltip-floor--price');
        let area = obj.$tooltip.find('.tooltip-floor--area');

        let _floor = '';
        let _house = '';

        let apart_url = obj.$container.data('url');
        if(obj.$container.data('floor') !== 0) {
            $.each(apart_data[obj.$container.data('house')][obj.$container.data('floor')], function (key) {
                let info = this;
                let $apart = $('#' + key);
                if ($apart.length > 0) {
                
                    $apart
                        .addClass('status-' + info.status)
                        .attr('href', apart_url + key)
                        .on('mouseenter', function () {
                            obj.$tooltip.addClass('show');

                            if (info.status === 'Parduotas') {
                                obj.$tooltip.addClass('empty');
                            } else {
                                obj.$tooltip.addClass('available');
                            }

                            if(info.rooms == 0) type.html('KOMERCINĖS');
                            else type.html('BUTAS');

                            nr.html(info.nr);
                            status.html(info.status);
                            area.html(info.area + ' M<sup>2</sup>');

                            if (typeof info.price !== 'undefined' && info.price != 0) {
                                price.html(info.price + ' €').show();
                            } else {
                                price.hide();
                            }


                        }).on('mouseleave', function () {

                        obj.$tooltip
                            .removeClass('show')
                            .removeClass('empty')
                            .removeClass('available');

                    }).on('mousemove', function (e) {

                        let left = e.clientX;
                        let top = e.clientY;

                        obj.$tooltip
                            .css({
                                top: top + -(obj.$container[0].getBoundingClientRect().y) - obj.$tooltip.height() - 10,
                                left: left - obj.$container[0].getBoundingClientRect().x + 10,
                                opacity: 1
                            });
                    });
                }
            });

        }else {

            $.each(apart_data[obj.$container.data('house')][0], function (key) {
                let info = this;

                let $park = $('#' + info.nr);
                if ($park.length > 0) {
                    type.html('PARKINGAS');
                    area.hide();
                    $park
                        .addClass('status-' + info.status)
                        .attr('href', apart_url + key)
                        .on('mouseenter', function () {
                            obj.$tooltip.addClass('show');

                            if (info.status === 'Parduotas') {
                                obj.$tooltip.addClass('empty');
                            } else {
                                obj.$tooltip.addClass('available');
                            }

                            nr.html(info.nr);
                            status.html(info.status);
                            //   area.html(info.area);

                            if (typeof info.price !== 'undefined' && info.price != 0) {
                                price.html(info.price + ' €').show();
                            } else {
                                price.hide();
                            }

                        }).on('mouseleave', function () {
                        obj.$tooltip
                            .removeClass('show')
                            .removeClass('empty')
                            .removeClass('availble');
                    }).on('mousemove', function (e) {

                        let left = e.clientX;
                        let top = e.clientY;

                        obj.$tooltip
                            .css({
                                top: top + -(obj.$container[0].getBoundingClientRect().y) - obj.$tooltip.height() - 10,
                                left: left - obj.$container[0].getBoundingClientRect().x + 10,
                                opacity: 1
                            });
                    });
                }

                // console.log(this);

            })

        }

    }
}
const paralax = {
    class : '.prlx',
    timelines: [],
    init: function(cont = document){
        let obj = this;
        let $items = $(obj.class);
        if($items.length > 0){

            $.each($items, function(){
                let $item = $(this);
                let tl = gsap.timeline({
                    force3D: true,
                    scrollTrigger: {
                        trigger: $item[0],
                        start: "top 90%", // when the top of the trigger hits the top of the viewport
                        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                    }})

                if($item.data('prlx') === 'right-left'){
                    let $img = $item.find('img');
                    tl.fromTo($img,
                        {
                            x:0
                        },
                        {
                            x: $img.width() - $item.width()
                        });
                }
                obj.timelines.push(tl);
            });

        }
    },
    resize: function(){
        let obj = this;
        $(window).resize(function(){
            if(obj.timelines.length > 0){
                $.each(obj.timelines, function(){
                    this.kill();
                })
            }
            obj.timelines = [];
            obj.init();
        })
    }
}

const paralaxCircle = {
    class : '.prlx-circle',
    init: function(cont = document){
        let obj = this;
        let $items = $(obj.class);

        if($items.length > 0) {
            $.each($items, function (){
                let $item = $(this);
                let $parent = $item.parent();

                let tl = gsap.timeline({
                    force3D: true,
                    scrollTrigger: {
                        trigger: $parent[0],
                 //       markers: true,
                        toggleActions: "play none none none",
                        //pin: true,   // pin the trigger element while active
                        start: "90% 80%", // when the top of the trigger hits the top of the viewport
                        end: "bottom 50%",
                        //end: "+=500", // end after scrolling 500px beyond the start
                       //scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                    }})

                tl.fromTo($item.find('.circle-img'),
                    {
                        scale: 0,
                    } ,
                    {
                        transformOrigin: "center center",
                        scale:1,
                        duration: 0.35,
                        force3D:true,
                        rotate: 0.001,
                        //ease:'none'
                    })

                let $text = $($item).find('.chat-default');

                tl.fromTo($text,
                    {
                        scale: 0
                    } ,
                    {
                        scale:1,
                        stagger: 0.3,
                        duration: 0.5,
                        transformOrigin: 'right center',
                        force3D:true,
                        rotate: 0.001,
                        onComplete: function(){

                        }
                    },'-=0.2')

            })


        }
    }
}

const dots = {
    class : '.chat-typing',
    init: function(){
        let obj = this;
        let $items = $(obj.class);
        if($items.length > 0){
            $.each($items, function(){
                let $dots = $(this).find('.chat-dot');
                gsap.fromTo($dots,
                    {
                        scale: 1
                    },
                    {
                        scale: 1.5,
                        stagger:3,
                        repeat: -1
                    });
            })

        }
    }
}

const tooltips = {
    init: function(container = document){

        let $items = $(container).find('.has-tooltip');

        if($items.length > 0){
            $items.on('mouseenter',function(){
                let $this = $(this);
                $this.addClass('show');


            }).on('mouseleave', function(){
                let $this = $(this);
                $this.removeClass('show');
            })
        }


    }
}

const reaveal = {
    init: function(container = document){
        let obj = this;

        let $reveals = $(container).find('.reveal');

        $.each($reveals,function(){
            let $this = $(this);

            let tl = gsap.timeline({
                force3D: true,
                scrollTrigger: {
                    trigger: $this[0],
                    //  markers: true,
                 //   toggleActions: "play none reverse none",
                    //pin: true,   // pin the trigger element while active
                    start: "top 100%", // when the top of the trigger hits the top of the viewport
                    end: "bottom 100%",
                //   markers: true
                    //end: "+=500", // end after scrolling 500px beyond the start
                    // scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                }});

            tl.fromTo($this,{
                y: 50,
                autoAlpha: 0
            }, {
                y: 0,
                autoAlpha:1,
            });

        })

       /* let $staggers = $(container).find('.staggerFadeIn');

        $.each($staggers,function(){
            let $this = $(this);
            let $children = $this.children();
            let delay = $this.data('delay');


            let start  = 'top 100%';

         //   console.log(delay);

         //   console.log(typeof delay);
            if(delay !== 'undefined'){
                start = 'top '+delay+'';
            }else{
                start  = 'top 100%';
            }

            // data-delay kazkodel reik kitaip fck all veikia


            let tl = gsap.timeline({
                force3D: true,
                scrollTrigger: {
                    trigger: $this[0],
                   // markers: true,

                  //  toggleActions: "play none reverse none",
                    //pin: true,   // pin the trigger element while active
                    start: 'top '+delay,
                   // end: "bottom 100%",
             //       markers: true
                    //end: "+=500", // end after scrolling 500px beyond the start
                    // scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                }});

            tl.fromTo($children,{
                autoAlpha: 0
            }, {
                stagger: 1/$children.length,
                autoAlpha:1,
            });


        });


*/
    }
}

const staggers = {
    class: '.staggerFadeIn',
    init: function(container = document){
        let obj = this;

        let $staggers = $(container).find(obj.class);

        $.each($staggers, function(){
            let $this = $(this);
            let $children = $this.children();
            switch($this.data('type')){


                case(2):



                    break;
                case(1):

                    ScrollTrigger.batch($this, {
                        //interval: 0.15,
                        start: "top 90%",
                        onEnter: function(){
                            $children.each((index ,item) => {
                                gsap.timeline().to(item, {
                                        overwrite: true,
                                        onStart: function(){
                                            $(item).addClass('show');
                                        },
                                        duration: 0.55,
                                        delay: index * 0.15,
                                    }
                                    // delay: index * 0.15}
                                );
                            })
                        },
                      //  markers: true
                    });
                    break;
                default:
                    gsap.set($this.children(),{autoAlpha:0})
                    ScrollTrigger.batch($this.children(), {
                        //interval: 0.15,
                        start: "top 90%",
                        onEnter: function(batch){
                         //   console.log(batch);
                        //   gsap.set(batch, {opacity: 0, x: 250});
                            batch.forEach((item, i) => {

                                gsap.timeline().to(item,{
                                    onStart:function(){
                                      //  console.log(this);
                                        $(item).addClass('show');
                                    },
                                    autoAlpha: 1,
                                    overwrite: true,
                                    duration: 0.75,
                                    delay: i * 0.15
                                });
                            })
                        },
                     //   markers: true
                    });


            }


        })
    }


}

const photos = {
    class: '.photos',
    init: function(container = document){
        let obj = this;
        let $cont = $(container).find(obj.class);

        $.each($cont, function(){
            let $this = $(this);
            let $photos = $this.find('.photo');
            let $txt = $this.find('.photos-txt');
            let $like = $this.find('.photos-like');
            let $count = $this.find('.photos-like--counter');

            $this.on('click', function(){
                if(!$(this).hasClass('clicked')) {
                    let nr = parseInt($count.html());
                    $(this).addClass('clicked');
                    if (nr === 999) { return false;}
                    $count.html(nr + 1);
                    $.ajax({
                        url: $('base').attr('href')+'favorites/likes',
                        data: {id:$this.data('photos')},
                        type: 'POST'
                    });


                }
            })

            let tl = gsap.timeline({
                force3D: true,
                paused: true
            });

            ScrollTrigger.create({
                    trigger: $this[0],
                    toggleActions: "play none reverse none",
                    start: '10% 70%',
                 //   markers: true,
                    onEnter: function(){
                        tl.play();
                    },
                  //  markers: true,
                });

            let delay = 0;
            if(typeof $this.data('delay') !== 'undefined'){
                delay = $this.data('delay');
            }

            tl.from($photos[0], {
                duration:0.3,
                autoAlpha:0,
                rotate: 0,
                delay: delay,
                y:'20%',
               // yPercent: 20,
                onStart:function(){
                        gsap.fromTo($($photos[0]).find('img'),{autoAlpha:0},{autoAlpha:1,delay:0.35})
                }})
                .from($photos[1], {
                    duration:0.45,
                    autoAlpha:0,
                    rotate: 0,
                    delay:0.4,
                    y:'9%',
                    //yPercent: 5,
                    onStart:function(){
                        gsap.fromTo($($photos[1]).find('img'),{autoAlpha:0},{autoAlpha:1,delay:0.35})
                    }
                },'-=0.05');

            let tl2 = gsap.timeline({
                force3D: true,
                paused: true
            });

            let mySplitText = new SplitText($txt.find('span'),
                { type: "chars" }),
                chars = mySplitText.chars;

            tl2.fromTo(chars,
                {
                    autoAlpha:0,
                    y:25
                },
                {
                    autoAlpha:1,
                    y:0,
                    stagger: 0.007,
                    delay:0.8 + delay,
                })
                .fromTo($like,
                    {
                        scale:0
                    },{
                    duration:0.3,
                    scale:1
                },'-=0.4');


            ScrollTrigger.create(
                {
                    trigger: $this[0],
                    toggleActions: "play none reverse none",
                    start: '90% 95%',
                    onEnter: function(){
                        tl2.play();
                    },
                 //   markers: true,
                }
            );

        })
    }
}


const txt ={

    words:[
        'geriau',
        'jaukiau',
        'maloniau',
        'savo namuose'],
    txt: [],
    split: null,
    tl : null,
    delay: 0.5,
    init: function(container = document){
        let obj = this;
        let $cont = $(container).find('.txt-rotate');
        let $txt = $($cont).find('span');

        $cont.html(obj.words[0]);
        let i = 0;
        obj.split = new SplitText($cont, { type: "words,chars" });

        function animTxt(){
            if(obj.tl !== null){
                obj.tl.kill();
            }

            obj.tl = gsap.fromTo(obj.split.chars,
                {
                    autoAlpha:0,
                    y:25
                },
                {
                    onStart:function(){
                        gsap.to($cont,{autoAlpha:1});
                    },
                    autoAlpha:1,
                    duration:1,
                    y:0,
                    stagger: 1/obj.split.chars.length,
                    delay:obj.delay,
                    rotation: 0.001,
                    // repeat: -1,
                    onComplete: function(){
                        gsap.fromTo(obj.split.chars, {
                            autoAlpha:1,
                            y:0,
                        },{
                            autoAlpha:0,
                            y:25,
                            immediateRender: false,
                            stagger: 1/obj.split.chars.length,
                            delay:1.5,
                            onComplete:function(){
                                i++;
                                if(i === obj.words.length){
                                    i = 0;
                                }
                                gsap.to($cont,{
                                    autoAlpha:0,
                                    duration:0.02,
                                    onComplete:function(){
                                        $cont.html(obj.words[i]);
                                        obj.split = new SplitText($cont, { type: "words,chars" });
                                        if(obj.tl !== null) {
                                            obj.tl.kill();
                                        }
                                        obj.tl = null;
                                        obj.delay = 0.005;
                                        animTxt();
                                    }});
                            }
                        })
                    }
                })

        }
        animTxt();
    }
}


const messenger = {
    init: function(container = document){
        let obj = this;
        let $cont = $(container).find('.sct-intro2--chatCont');

        if($cont.length === 0 ){ return false;}

        let $blocks = $cont.find('.sct-intro2--chatBlock');

        gsap.set($blocks.children(),{autoAlpha: 0});

        ScrollTrigger.batch($blocks, {
            start: 'top 55%',
            end: 'top 30%',
            onEnter: (elements, triggers) => {
                let $type = $(elements).find('.chat-typing');

                if($type.length > 0){
                    $.each($type.find('.chat-dot'), function(index, el){
                        let tl = gsap.timeline({repeat:-1,delay: 0.2*index});
                        tl
                            .fromTo(el,{autoAlpha:0},{autoAlpha: 1,duration:1,ease:'none'})
                            .fromTo(el,{autoAlpha:1},{autoAlpha: 0,duration:1,ease:'none', immediateRender:false})
                    })
                }
                gsap.to($(elements).children(), {autoAlpha: 1, stagger: 0.15});
            },
            onLeave: (elements, triggers) => {
                $(elements).addClass('hide-typing');
                gsap.killTweensOf($(elements).find(".chat-dot"));

            }
        });

    }
}
const aparts = {


    init: function(container = document){

        let obj = this;
        let $nav = $(container).find('.plan-toggle');
        let $left = $(container).find('.img-plan--navLeft');
        let $right = $(container).find('.img-plan--navRight');
        let $imgs = $(container).find('.img-plan');

        $nav.on('click', function(){
            $nav.removeClass('active');
            $imgs.removeClass('active');
            let $this = $(this);
            $this.addClass('active');
            let type = $this.data('cat');
            $(container).find('.img-plan[data-cat="'+type+'"]').addClass('active');
        })

        $left.on('click',function(){
            $nav.removeClass('active');
            let $this = $(this);
            let $parent = $this.parent();
            $parent.removeClass('active');
            let $prev = $parent.prev();
            $prev.addClass('active');
            $(container).find('.plan-toggle[data-cat="'+$prev.data('cat')+'"]').addClass('active');

        })

        $right.on('click',function(){
            $nav.removeClass('active');
            let $this = $(this);
            let $parent = $this.parent();
            $parent.removeClass('active');
            let $next = $parent.next();
            $next.addClass('active');
            $(container).find('.plan-toggle[data-cat="'+$next.data('cat')+'"]').addClass('active');

        })

        var house_nr = $(container).find('.sct-apartment').data('house');

        var floor_nr = $(container).find('.sct-apartment').data('froors');

        let $floor = $(container).find('.svg-houses a[data-house="'+house_nr+'"][data-floor="'+floor_nr+'"]');

        if($floor.length > 0){
            $floor.addClass('current');
        }


        $('[data-fancybox="apartment"]').fancybox({
            afterLoad : function(instance, current) {

                let $svg = current.$content.find('.svg-houses a[data-house="'+house_nr+'"][data-floor="'+floor_nr+'"]');
                if($svg.length > 0){
                    $svg.addClass('current');
                }
            }
        });

    }
}
const forms = {

    init: function(container = document){
        const $form = $(container).find('.form');

        $form.submit(function(e){
            e.preventDefault();
            let $this = $(this);

            $this.find('.has-error')
                .removeClass('has-error')
                .find('.form-field--error')
                .html('');

            $.ajax({
                url:$this.attr('action'),
                data: $this.serialize(),
                type: 'POST'
            }).done(function( data ) {
                if(data.status === 0){
                    $.each(data.errors, function(){
                      //  console.log(this);
                        $this.addClass('show-error');
                        $this
                            .find('#field-'+this[1])
                            .parents('.form-row')
                            .addClass('has-error')
                            .find('.form-error')
                            .html(this[0]);
                    });
                    $this.find('.form-footer--error').addClass('has-error');

                    if($(document).width() < 1024){
                        $this.find('.form-errors').fadeIn();
                    }
                }else{
                    $this.addClass('show-success');
                    $this.find('.form-errors').hide();
                    
                    if(typeof gtag === "function") gtag('event','issiuntimas', {'event_category': 'forma','event_label': 'siusti uzklausa'});
                    if(typeof fbq === "function")  fbq('track', 'CompleteRegistration', {content_name: "siusti uzklausa"});
                }
                ScrollTrigger.refresh()
            })
        })

        const $inputs = $(container).find('.form-row--input input');

        $inputs.on('keyup', function(){
            let $this = $(this);
            let $parent = $this.parent();
            $this.parents('.form-row').removeClass('has-error');
            if($this.val() === ''){
                $parent.removeClass('floatLabel');
            }else{
                $parent.addClass('floatLabel');
            }
        })

        const $checks = $(container).find('.form-row--checkbox input');

        $checks.on('change', function(){
            $(this).parent().removeClass('has-error');
        } )

    }
}
const news = {
    page: 2,
    init: function(container = document){
        let obj = this;
        let $load = $(container).find('.sct-news--load');
        let $hold = $(container).find('.sct-news--cont');


        $load.on('click', function(e){
            e.preventDefault();
            let $this = $(this);

            $.ajax({
                url:window.location.href,
                data: {page: obj.page},
                type: 'POST'
            }).done(function( data ) {
                data = JSON.parse(data);
                obj.page = obj.page + 2;
                if(obj.page >= data.total){
                    $this.fadeOut();
                }
                $hold.append(data.html);
                triggerResize();
                createBatch($hold.find('.sct-news--item').not('.showed'));
            });
        })

        function show(batch) {
            gsap.set(batch, {opacity: 0, y: 50});

            batch.forEach((item, i) => {
                // Do whatever you want with each item in the batch
                gsap.timeline().to(item, {opacity: 1, y:0, overwrite: true, duration: 0.75, delay: i * 0.15, onStart:function(){
                    $(item).addClass('showed');
                }});
            })
        }

        function hide(batch) {
            gsap.set(batch, {opacity: 0, y: 50, overwrite: true});
        }

        function createBatch(target) {
            ScrollTrigger.batch(target, {
                //interval: 0.15,
                start: "top 85%",
                onEnter: show,
              //  toggleActions: "play none none none",
                onLeave: hide,
                onEnterBack: show,
                onLeaveBack: hide
            });
        }


        createBatch($(container).find('.sct-news--item'));
    }
}
const galleries = {

    trigger: null,
    init: function(container = document){
        let obj = this;

        let $btns = $(container).find('.gallery-toggle');

        let $imgs = $(container).find('.sct-gallery--photos');

        $btns.on('click', function(e){
            e.preventDefault();
            let $this = $(this);

            $btns.removeClass('active');
            $this.addClass('active');
            $imgs.removeClass('show-1').removeClass('show-2');
            $imgs.addClass('show-'+$this.data('gallery'));

            $imgs
                .find('a')
                .removeClass('active');

            $imgs
                .find('[data-gallery="'+$this.data('gallery')+'"]')
                .addClass('active');
        }).on('mouseover',function(e){

        })


        $imgs.find('a').on('click', function(e){
            e.preventDefault();
            let $this = $(this);
            $(container).find('[data-fancybox="gallery-'+$this.data('gallery')+'"]').first().trigger('click');
        });

        let $links = $(container).find('.gallery-links');

        $links.fancybox({
            beforeShow: function(instance, slide){
                instance.$refs.container.addClass('fbGallery');
            },
            buttons : ['close'],
            btnTpl: {
                close:
                    '<button data-fancybox-close class="fancybox-button  fancybox-button--close fancybox-button--closeCustom" title="{{CLOSE}}">' +
                    '<svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg">' +
                        '<circle class="circle-base" cx="55" cy="55" r="50"></circle>' +
                        '<circle class="circle-hover" cx="55" cy="55" r="50"></circle>' +
                    '</svg>' +
                    "</button>",
                arrowLeft:
                    '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left fancybox-button--Gallery_left" title="{{PREV}}">' +
                    '<div>' +
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8.4 14.3" style="enable-background:new 0 0 8.4 14.3;" xml:space="preserve"><polyline style="fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;" points="7.2,1.1 1.2,7.1 7.2,13.1 "/></svg>' +
                    '</div>' +
                    "</button>",
                arrowRight:
                    '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right fancybox-button--Gallery_right" title="{{NEXT}}">' +
                    '<div>' +
                    '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8.4 14.3" style="enable-background:new 0 0 8.4 14.3;" xml:space="preserve"><polyline style="fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;" points="1.2,13.1 7.2,7.1 1.2,1.1 "/></svg>' +
                    '</div>' +
                    "</button>",
            }
        })

        if($(document).width() > 860 && obj.trigger === null){
            obj.gallery(container);
        }

        $(window).resize(function(){

            if($(document).width() > 860 && obj.trigger === null){
                obj.gallery(container);
            }else if($(document).width() <= 860){
                obj.destroy()
            }
        })

    },
    gallery: function(container){
        let $gallery = $(container).find('.sct-gallery');
        if($gallery.length > 0) {
            setTimeout(function () {
                galleries.trigger =  ScrollTrigger.create({
                    trigger: $gallery,
                    start: "top top",
                    end: '+='+($(window).height()),
                    scrub: 1,
                    anticipatePin: 1,
                    pin: true,
                    onUpdate: function(self){
                        if(self.progress > 0.1) {
                            if (self.direction === 1) {
                                $(container).find('.gallery-toggle[data-gallery="1"]').trigger('click');
                            } else {
                                $(container).find('.gallery-toggle[data-gallery="2"]').trigger('click');
                            }
                        }
                    }
                });
                ScrollTrigger.refresh();
            }, 100);
        }

    },
    destroy: function(){
        let obj = this;
        if(obj.trigger !== null) {
         //   console.log('destroy');
            obj.trigger.kill();
            obj.trigger = null;
        }
    }
}
const svgMap = {

    drag : null,
    init: function(container = document){
        let obj = this;

        let $zones = $(container).find('[data-tooltip]');
        let $cont = $(container).find('.svg-map');


        $.each($zones, function(){
            let $this = $(this);
            let id = $this.data('tooltip');

            if(id.length > 0){
                let $tooltip = $('#'+id);
                $this.mouseenter(function(e){
                    $tooltip.addClass('active');
                }).mouseleave(function () {
                    $tooltip.removeClass('active');
                })
            }
        })

        $(window).resize(function(){
            if($(window).width() < 1024){
                obj.drag.enable();
                gsap.set('.svg-map--container',{x:(obj.drag.minX/2),force3D: true})
                obj.drag.update();
            }else{
                obj.drag.disable();
                gsap.set('.svg-map--container',{x:0,force3D: true})
            }
        })

         Draggable.create(".svg-map--container", {
            type:"x",
            bounds: $(container).find('.sct-intro4'),
            // inertia: true,
            onClick: function() {
               // console.log("clicked");
            },
            onDragEnd: function() {
             //   console.log("drag ended");
            }
        });

        obj.drag = Draggable.get(".svg-map--container");

        if($(window).width() > 1023){
            obj.drag.disable();
        }else{
            gsap.set('.svg-map--container',{x:(obj.drag.minX/2),force3D: true})
            obj.drag.update();
        }
    }
}
const menu = {
    init: function(container = document){
        let obj = this;

        let $links = $(container).find('.menu-link');
        let $imgs = $(container).find('.menu-photos')

        $links.mouseenter(function(e){
            let $this = $(this);
            let img = $this.data('img');
            $imgs.removeClass('show1').removeClass('show2').removeClass('show3');
            $imgs.addClass('show'+img);
        })
    },

    trigger: null,
    stiky: function(container = document){
        let obj = this;

        let $menu = $(container).find('.sticky-menu');

        if($menu.length > 0){
            setTimeout(function(){
                obj.trigger = ScrollTrigger.create({
                    trigger: $menu,
                    start: "top 83px",
                    end: "top 83px",
                    endTrigger: '.sct-rooms',
                    scrub: 1,
                    anticipatePin: 1,
                    pin: true,
                    pinSpacing: false,
                    // toggleClass : 'pinned',
                   // markers: true
                });
            },600);

            let $links = $menu.find('button');

            $.each($links, function(){

                let $this = $(this);
                setTimeout(function(){
                    ScrollTrigger.create({
                        trigger: $($this.data('target')),
                        start: "top bottom",
                    //    markers: true,
                        onEnter: function(){
                            $links.removeClass('active');
                            $this.addClass('active');
                        },
                        onLeave: function(){
                            $this.removeClass('active');
                        },
                        onEnterBack: function(){
                            $links.removeClass('active');
                            $this.addClass('active');
                        },
                        onLeaveBack: function(){
                            $this.removeClass('active');
                        }
                    });
                },600);
            })
        }



        function end(){
            return  $(container).height()
        }
        function offset(){
            return $(document).width() / 100 * 8;
        }
    },
    sticky_kill: function(){
        let obj = this;
        if(obj.trigger !== null){
            obj.trigger.kill(true);
            obj.trigger = null;
        }
    },
    links: function(container = document){
        let obj = this;

        let $links = $(document).find('.menu-link');
        let $logo = $(document).find('.header-logo');

        $logo.on('click', function(){
            $links.removeClass('active');
        });

        $links.on('click', function(){
            let $this = $(this);
            $links.removeClass('active');
            $this.addClass('active');
        });


        let $banks = $('.banks-title');

        $('.banks-title--open').click(function(e){
            e.preventDefault();
            $banks.toggleClass('active');
        });

        $('.banks-popup--close').click(function(){
            $banks.removeClass('active');
        })
    },
    change: function(type){
        let $links = $(document).find('.menu-link');
        $links.removeClass('active');
        $.each($links, function(){
            let $this = $(this);
            if($this.data('slug') === type){
                $this.addClass('active');
            }
        })
    }
};
const favs = {

    init: function(container = document){
        const $favHeader = $('.header-fav');
        const $favCounter = $(document).find('.header-fav--counter');
        $(document).on('click', '.add-favorite', function(e){
            let $this = $(this);
            let id = $this.data('id');
            let $favs = $(container).find('.form-row--favsInputs');

            if($('.sct-favorites').length > 0){
                $this.parents('tr').remove();
                triggerResize();
            }

            $.ajax({
                url:$('base').attr('href')+'favorites/favoritesToggle',
                data: {id: id},
                type: 'POST'
            }).done(function( data ) {
                $this.toggleClass('favorited');
                data = JSON.parse(data);
                $favCounter.html(data.favs);

                let $txt = $this.find('.tooltip-hover--inner');
                if($(container).find('.sct-apartment').length === 0) {
                    if ($this.hasClass('add-favorite') && $this.hasClass('favorited')) {
                        $txt.html('Pašalinti iš pamėgtų');
                        $this.removeClass('small');
                        if ($favs.length > 0) {
                            var field = '' +
                                '<input id="field-favs--' + id + '" name="post[favs][]" checked="" value="' + id + '">' +
                                '<label for="field-favs--' + id + '" class="form-row--favsCheckbox">' +
                                '<span class="form-row--favsCheckboxLabel">' + data.nr + '</span>' +
                                '<span class="form-row--favsCheckboxRemove"></span>' +
                                '</label>';
                            $favs.append(field);
                        }
                    }

                    if($this.hasClass('add-favorite') && !$this.hasClass('favorited')){
                    $txt.html('Įsiminti');
                    $this.addClass('small');
                    if ($favs.length > 0) {
                        $('#field-favs--' + id).remove();
                        $('label[for="field-favs--' + id + '"]').remove();
                    }
                }
                }
            });
        })

    },
    form: function(container = document){
        $(document).on('click', '.form-row--favsCheckbox', function(){
            let $this = $(this);
            let id = $this.attr('for');

            $this.remove();
            $('#'+id).remove();

        })



    }


}
const vidMask = {
    v: {
        mouse: {
            x: window.innerWidth * 0.5,
            y: window.innerHeight * 0.5,
            rx: 0.5,
            ry: 0.5
        },
        ww: window.innerWidth,
        wh: window.innerHeight,

        el: null,
        first: true,
        o: {
            x:0.5,
            y:0.5,
            o:0.6
        },
        setX: null,
        setY: null,
        setO: null,

        visible: false
    },

    init: function(cnt){
        let $t = this;
        let v = $t.v;
        v.el = $(cnt).find(".sct-intro--video");
        if(!v.el){
            console.error("vidMask: Video container not found!");
            return false;
        }
        if(v.first){
            v.first = false;
            v.setX = gsap.quickTo(v.o, "x", {duration: 0.8, ease: "power3", onUpdate: function(){
                v.el.css("--x", v.o.x);
            }});
            v.setY = gsap.quickTo(v.o, "y", {duration: 0.8, ease: "power3", onUpdate: function(){
                v.el.css("--y", v.o.y);
            }});
            v.setO = gsap.quickTo(v.o, "o", {duration: 1.4, ease: "power3", onUpdate: function(){
                v.el.css("--o", v.o.o);
            }});
        }
        v.el.css("--x", v.o.x).css("--y", v.o.y).css("--o", v.o.o);
        window.addEventListener("mousemove", $t.mmove);
        window.addEventListener("resize", $t.rsz);
        document.documentElement.addEventListener('mouseleave', $t.lv);
    },

    deinit: function(){
        let $t = this;
        let v = $t.v;
        window.removeEventListener("mousemove", $t.mmove);
        window.removeEventListener("resize", $t.rsz);
        document.documentElement.removeEventListener('mouseleave', $t.lv);
        v.visible = false;
        v.o.o = 1;
    },

    mmove: function(e){
        let $t = vidMask;
        let v = $t.v;
        let m = v.mouse;
        m.x = e.pageX;
        m.y = e.pageY;
        m.rx = m.x / v.ww;
        m.ry = m.y / v.wh;
        if(m.ry > 1 && !v.visible && v.o.o == 1) return false;
        if(m.ry > 1 && v.visible){
            v.setO(1);
            v.visible = false;
        }else if(m.ry <= 1 && !v.visible){
            v.o.x = m.rx;
            v.o.y = m.ry;
            v.setO(0);
            v.visible = true;
        }
        v.setX(m.rx);
        v.setY(m.ry);
    },

    rsz: function(e){
        let $t = vidMask;
        let v = $t.v;
        v.ww = window.innerWidth;
        v.vh = window.innerHeight;
    },

    lv: function(e){
        let $t = vidMask;
        let v = $t.v;
        v.setO(1);
        v.visible = false;
    }
};

window.vidMask = vidMask;

const map = {
    container : '#map',
    map : null,
    styleClass: 'gmap',
    instance: null,
    controls: '.sct-map--control',
    main: null,
    markers: [],
    infoWindows: [],
    toggle: '',
    cat : 0,
    options: {
        center: null,
        zoom: 16,
        panControl: false,
        mapTypeControl: false,
        overviewMapControl: false,
        scaleControl: false,
        streetViewControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
        },

        styles:[
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#73b2b9"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#73b2b9"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#5d8489"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#cfe5e8"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#73b2b9"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#5a9ba2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#cfe5e8"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#73b2b9"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#7ebda3"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#608b90"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#cfe5e8"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#98c7cd"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#b9d8dc"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#99c8cd"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#99c8cd"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#99c8cd"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#59a2aa"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#cbe4e9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#cfe5e8"
                    }
                ]
            }
        ],
    },
    init: function(container = document){
        let obj = this;

        if(typeof mapPoints === 'undefined'){
            console.log('No main data');
            return false;
        }

        if(typeof mapMain === 'undefined'){
            console.log('No main marker')
        }


        if(obj.instance === null){
            obj.options.zoom = parseInt(mapMain.zoom);
            mapMain.coords = mapMain.coords.split(',');
            mapMain.center = mapMain.center.split(',');


            obj.options.center =  new google.maps.LatLng(mapMain.center[0], mapMain.center[1]);


            obj.instance = obj.createNewInstance();

            obj.createMarkers();
        }


       let $btns = $(container).find(obj.controls);

        //   let bounds = new google.maps.LatLngBounds();

        if(obj.cat !== 0) {
            $(container).find(obj.controls+'[data-cat="'+obj.cat+'"]').addClass('active');
        }

        $btns.click(function(e){
            e.preventDefault();
            let $this = $(this);
            let cat = $this.data('cat');
            let bounds = new google.maps.LatLngBounds();
            bounds.extend( new google.maps.LatLng(mapMain.coords[0], mapMain.coords[1]));
            if($this.hasClass('active')){
                $this.removeClass('active');
                $.each(obj.markers, function(i, marker){
                    if(typeof marker !== 'undefined') {
                        marker.setMap(obj.instance.map);
                        bounds.extend(marker.position);
                    }
                });
                obj.cat = 0;
            }else {
                $btns.removeClass('active');
                $this.addClass('active');
                $.each(obj.markers, function (i, marker) {
                    if(typeof marker !== 'undefined'){

                        if (parseInt(marker.type) == cat) {
                            marker.setMap(obj.instance.map);
                            bounds.extend(marker.position);
                        } else {
                            marker.setMap(null);
                        }
                    }
                });
                obj.cat = cat;
            }
            obj.instance.map.fitBounds(bounds);
            if($(window).width() < 870){
                gsap.to(window, {scrollTo: ($(container).find('#map').offset().top )});
            }
        });

        $(container).find(obj.container).html(obj.instance['div']);

    },
    createNewInstance : function(){
        let obj = this;
        let div = $("<div></div>").addClass(this.styleClass);
        let map =   new google.maps.Map(div[0], obj.options);

        let array = [
            new google.maps.LatLng(54.73561529530633, 25.214630564999275),
            new google.maps.LatLng(54.73565436099415, 25.21640786736905),
            new google.maps.LatLng(54.734422471504345, 25.21640786736905),
            new google.maps.LatLng(54.73452664965523, 25.215262093760106),
            new google.maps.LatLng(54.7347350051534, 25.214472682809067),
        ];

        const area = new google.maps.Polygon({
            paths: array,
            strokeColor: "#7291a1",
            strokeOpacity: 1,
            strokeWeight: 1,
            fillColor: "#7291a1",
            fillOpacity: 1,
        });
        area.setMap(map);


        return {
            map: map,
            div: div
        }
    },
    createMarkers : function(){
        let obj = this;
        if(obj.instance.length === 0){
            console.log('No map instance ');
            return false;
        }

        //  let bounds = new google.maps.LatLngBounds();
        if(typeof mapPoints !== 'undefined'){

            $.each(mapPoints, function(i, marker){
                let icon;
                icon = {
                    url: 'assets/svg/map_'+marker_types[marker.category].svg,
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 27),
                    scaledSize: new google.maps.Size(54, 54)
                };


                obj.markers[i] = new google.maps.Marker({
                    position: new google.maps.LatLng(marker.lat, marker.lng),
                    title: marker.title,
                    map: obj.instance.map,
                    icon: icon,
                    visible: true,
                    zIndex: 80,
                    main: false,
                    type: marker.category,
                    opened: false
                });

                //    bounds.extend(obj.markers[i].position);



                let infoContent =
                    '<div class="gmap-info">' +
                        '<div class="gmap-info--inner">' +
                            '<div class="gmap-info--time">'+marker.walk+'</div>' +
                            '<div class="gmap-info--title">'+marker.title+'</div>'
                        '</div>' +
                    '</div>';

                let infowindow = new google.maps.InfoWindow({
                    content: infoContent
                });
                infowindow.setZIndex(9999);
                obj.infoWindows.push(infowindow);


                google.maps.event.addListener(obj.markers[i], 'click', function () {
                    $.each(obj.infoWindows, function(){
                        this.close();
                    });

                    if(obj.markers[i].opened === false){
                        infowindow.open(obj.instance.map, obj.markers[i]);
                        obj.markers[i].opened = true;
                    }else{
                        obj.markers[i].opened = false;
                    }
                });

                google.maps.event.addListener(obj.instance.map, 'click', function () {
                    infowindow.close(obj.instance.map, obj.markers[i]);
                    obj.markers[i].opened = false;

                });

            });

        }

        if(typeof mapMain  !== 'undefined'){
            let icon;

            icon = {
                url: 'assets/svg/C_point.svg',
                origin: new google.maps.Point(0, 0),
                //     anchor: new google.maps.Point(116, 131),
                //      scaledSize: new google.maps.Size(116, 131)
                anchor: new google.maps.Point(29, 99),
                scaledSize: new google.maps.Size(58, 99)
            };

            obj.main = new google.maps.Marker({
                position: new google.maps.LatLng(mapMain.coords[0], mapMain.coords[1]),
                title: mapMain.title,
                map: obj.instance.map,
                icon: icon,
                visible: true,
                zIndex: 9999,
                main: true,
                type: 0
            });

            let title = JSON.parse(mapMain.title)

            let infoContent = '<div class="gmap-main ">' +
                '<div class="gmap-main--inner">' +
                    '<div class="gmap-main--streetA">'+title[0]+'</div><div class="gmap-main--streetB">'+title[1]+'</div>' +
                '</div>' +
            '</div>';

            let infowindow = new google.maps.InfoWindow({
                content: infoContent
            });

            google.maps.event.addListener( obj.main, 'click', function () {

                infowindow.open(obj.instance.map, obj.main);
                console.log(infowindow);
            });


            console.log( $(document).find('.gm-style-iw-d'));

            //    bounds.extend(obj.main.position);
        }
        //   obj.instance.map.fitBounds(bounds);
    },
    leave: function () {
        let obj = this;
        if(obj.$btns.length){
            obj.$btns.off();
            obj.$btns = null;
        }
    }



};

let scroller = ScrollSmoother.create({
    smooth: 1,               // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true,           // looks for data-speed and data-lag attributes on elements
    normalizeScroll: true
    //smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
});

window.onbeforeunload = function () {
    scroller.scrollTo(0, 0);
}

$(document).ready(function(){

 /*   let scroller = ScrollSmoother.create({
        smooth: 1,               // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true,           // looks for data-speed and data-lag attributes on elements
        smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });*/

    const $wrap = $('#wrap');

    barba.init({
        timeout: 3000,
        prevent:({ el }) => !el.classList.contains('js-barba') || el.classList.contains('status-Parduotas') || el.classList.contains('inactive') ,
        cacheIgnore: true,
        transitions: [ {
            name: 'no-transition',
            from: {
                namespace: [
                    'floor',
                    'apartment',
                    'parking',
                    'houses'
                ]
            },
            to: {
                namespace: [
                    'houses',
                    'parking',
                    'floor',
                    'apartment'
                ]
            },
            leave(data) {


            },
            enter(data) {
                scroller.scrollTo(0);
            },
            once() {
            }
        },{
            name: 'default-transition',
            leave(data) {
                const done = this.async();
                $menu.removeClass('active');
                gsap.to($wrap, {
                    opacity: 0,
                    duration: 0.2,
                    onComplete: function(){
                        scroller.scrollTo(0);
                    }
                })
                setTimeout(()=>{done();},350);
            },
            enter(data) {
                const done = this.async();
                gsap.fromTo($wrap, {
                    opacity: 0
                },{
                    delay:0.5,
                    opacity: 1
                });
                setTimeout(()=>{done();},350);
            },
            once() {
                //console.log("ONCE");
            }
        }],
        views: [
            {
                namespace: 'home',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    svgMap.init(data.next.container);
                    menu.stiky(data.next.container);
                    messenger.init(data.next.container);
                    txt.init(data.next.container);
                    photos.init(data.next.container);

                    let $tiggers = $(data.next.container).find('.scroll-to');
                    $tiggers.click(function(){
                        $tiggers.removeClass('active');
                        $(this).addClass('active');
                    });
                    vidMask.init(data.next.container);

                    let $videos = $(data.next.container).find('video');
                    $.each($videos, function(){
                        this.play();
                    })

                },
                beforeLeave(data){
                    vidMask.deinit();
                    if(txt.tl !== null){
                        txt.tl.kill();
                        txt.tl = null;
                    }
                },
                afterLeave(data){
                    menu.sticky_kill(data.next.container);
                }
            },
            {
                namespace: 'gallery',
                beforeLeave(data){
                    galleries.destroy();
                },
                beforeEnter(data) {

                },
                afterEnter(data) {
                    galleries.init(data.next.container);
                }
            },
            {
                namespace: 'map',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    map.init(data.next.container);
                }
            },
            {
                namespace: 'duk',
                beforeEnter(data) {

                },
                afterEnter(data) {

                }
            },
            {
                namespace: 'benefits',
                beforeEnter(data) {

                },
                afterEnter(data) {

                }
            },
            {
                namespace: 'offers',
                beforeEnter(data) {
                },
                afterEnter(data) {

                    $('.offer-sticky').fadeOut();
                },
                afterLeave(data){
                    $('.offer-sticky').fadeIn();
                }
            },
            {
                namespace: 'houses',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    houses.init(data.next.container ,scroller);
                    filter.init(data.next.container);
                    menu.change($(data.next.container).data('slug'));

                    if(window.location.hash) {
                        setTimeout(function () {
                          //  scroller.scrollTo('.filter',true, 'top 80px');

                            gsap.to(scroller, {
                                scrollTop: scroller.offset('.filter', 'top 10%'),
                                duration: 1,
                                onUpdate:function(){
                                    ScrollTrigger.refresh();
                                }
                            });
                        }, 700);
                    }

                }
            },
            {
                namespace: 'floor',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    filter.init(data.next.container);
                    floors.init(data.next.container);
                    menu.change($(data.next.container).data('slug'));
                }
            },


            {
                namespace: 'apartment',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    aparts.init(data.next.container);
                    menu.change($(data.next.container).data('slug'));
                }
            },
            {
                namespace: 'parking',
                beforeEnter(data) {

                },
                afterEnter(data) {

                }
            },
            {
                namespace: 'favorites',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    photos.init(data.next.container);
                    menu.change($(data.next.container).data('slug'));
                }
            }, {
                namespace: 'news',
                afterEnter(data) {
                    news.init(data.next.container);
                }
            },
            {
                namespace: 'furnishing',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    photos.init(data.next.container);
                }
            },
        ]
    });

    //global barba hooks
    barba.hooks.beforeEnter((data) => {

    });

    barba.hooks.before((data) => {

    });

    barba.hooks.enter((data) => {

        forms.init(data.next.container);
    });

    barba.hooks.afterEnter((data) => {

        scroller = ScrollSmoother.create({
            smooth: 1,               // how long (in seconds) it takes to "catch up" to the native scroll position
            effects: true,           // looks for data-speed and data-lag attributes on elements
            normalizeScroll: true
          //  smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
        });
        setTimeout(function() {
            tooltips.init(data.next.container);
            reaveal.init(data.next.container);
            paralax.init(data.next.container);
            paralaxCircle.init(data.next.container);
            staggers.init(data.next.container);
            ScrollTrigger.update();
            ScrollTrigger.refresh();
        },700);
    });

    barba.hooks.once((data)=> {
        tooltips.init();
        forms.init(data.next.container);
        scrolledHeader($(document).scrollTop());
      //  reaveal.init();
    });

    const $header = $('.header');
    $(document).scroll(function(e){
        scrolledHeader($(document).scrollTop());
    });

    function scrolledHeader(offset){
        if(offset > 0){
            $header.addClass('scrolled');
        }else{
            $header.removeClass('scrolled');
        }
    }

    const $burger = $('.burger');
    const $menu = $('.menu');

    $burger.on('click', function(e){
        e.preventDefault();
        $menu.toggleClass('active');
    });

    menu.init();

    $(document).on('click', '.scroll-to', function(e){
        e.preventDefault();
        let $this = $(this);
        let offset = $this.data('offset');
        $menu.removeClass('active');

        let position = 'top top';
        if(typeof offset !== 'undefined'){
            position = 'top 30%';
        }

        if(typeof $this.data('target') !== 'undefined'){
            gsap.to(scroller, {
                scrollTop: scroller.offset($this.data('target'), position),
                duration: 1,
                onUpdate:function(){
                    ScrollTrigger.refresh();
                }
            });
        }else{
            scroller.scrollTo(0);
        }
    });

    favs.init();
    favs.form();

    setTimeout(function(){
        ScrollTrigger.refresh();
        gsap.to($('#wrap'),{autoAlpha:1});
    }, 600);

    $(document).resize(function(){
        ScrollTrigger.refresh();
    });

    menu.links();
    paralax.resize();

    let cookie = Cookies.get('gdpr');
    const $gdpr = $('.gdpr');

    if(typeof cookie === 'undefined'){
        $gdpr.fadeIn();
    }
    $(document).on("click", ".accept-gdpr", function (e) {
        $gdpr.fadeOut();
        Cookies.set('gdpr', '1');
    });

    $(document).on('click','.status-Parduotas, .inactive', function(e){
        e.preventDefault();
        return false;
    })

    $(document).on('click','.form-cont label[for="field-6"]', function(e){
        if(typeof gtag === "function") gtag('event','sutikimas', {'event_category': 'naujienlaiskis','event_label': 'sutikimas gauti naujienlaiskius'});
        if(typeof fbq === "function") fbq('track', 'Newsletter', {content_name: "naujienlaiskis"});
    })

    $(document).on('click','.sct-contacts--broker .sct-contacts--brokerTel', function(e){
        let $this = $(this);
        let $parent = $this.parent();
        let data = $parent.data('id');
        if(data == 1) {
            if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas', 'event_label': 'Justinas tel. nr.'});
            if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Kontaktai +370 614 01391"});
        } else if(data == 2) {
            if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'Rasa tel. nr.'});
            if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Kontaktai +370 626 76029"});   
        } else if(data == 3) {
            if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'Denisas tel. nr.'});
            if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Kontaktai +370 618 33732"});
        }
    });

    $(document).on('click','.sct-contacts--broker .sct-contacts--brokerMail', function(e){
        let $this = $(this);
        let $parent = $this.parent();
        let data = $parent.data('id');
        if(data == 1) {
            if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'Justinas email'});
            if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Kontaktai justinas@lithome.lt"});
        } else if(data == 2) {
            if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'Rasa email'});
            if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Kontaktai rasa@lithome.lt"});
        } else if(data == 3) {
            if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'Denisas email'});
            if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Kontaktai denisas@lithome.lt"});
        }
    });

    //reset;
    $(document).on('click','.btn-reset', function(e){
        e.preventDefault();
        let $this = $(this);
        let form = $this.data('target');
        let $form = $(document).find(form);
        if($form.length > 0){
            let $inputs = $form.find('input');
            $.each($inputs,function(){
                $(this).prop('checked', false);
            });
            let $sliders = $form.find(".slider");
            $.each($sliders, function(){
                $(this).data("ionRangeSlider").reset();
            })
            $form.submit();
        }
    })

    if(typeof popuptime !== 'undefined') {

        var offerspopupShow = 1;

        var offerspopuptimer = setTimeout(function () {
                $.fancybox.open({
                    src: '#popup-offers',
                    type: 'inline',
                    baseClass: 'popup',
                    touch: false,
                    afterShow: function (instance) {
                        //instance.current.$content.find('.anim-fade-up').addClass('anim-trigger');
                        forms.init(instance.current.$content);
                        document.cookie = "popup-offers=1;expires=0;path=/";
                        offerspopupShow = 0;
                        scroller.paused(true);
                    },afterClose: function(){
                        scroller.paused(false);
                    }
                });
            }, popuptime
        );

        if (showLeave == 1) {

            $(document).mouseleave(function() {
                if ($('.fancybox-container.popup').length == 0 && offerspopupShow) {
                    $.fancybox.open({
                        src: '#popup-offers',
                        type: 'inline',
                        baseClass: 'popup',
                        touch: false,
                        afterShow: function (instance) {
                            //  instance.current.$content.find('.anim-fade-up').addClass('anim-trigger');
                            forms.init(instance.current.$content);
                            document.cookie = "popup-offers=1;expires=0;path=/";
                            offerspopupShow = 0;
                            scroller.paused(true);
                        },afterClose: function(){
                            scroller.paused(false);
                        }
                    });
                    clearInterval(offerspopuptimer);
                }
            });
        }
    }
});

function triggerResize(){
    var resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(resizeEvent);
}